import React, { useState, useContext} from 'react'
import Logo from '../../Assets/logo.png'
import { Link, useNavigate} from 'react-router-dom'
import '../../css/Main/NavBar.css'
import { VscAccount } from "react-icons/vsc";
import { FaCartShopping } from "react-icons/fa6";
import { CartContext } from '../../Context/CartProvider';
import { FaPhone } from "react-icons/fa6";
import { TiMail } from "react-icons/ti";

const NavBar = () => {
  const {count} = useContext(CartContext);
  const navigate = useNavigate()
  const [isOpen, setIsOpen] = useState(false);
  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };
  return (
    <div className='nav-container'>
        <div className='nav-category-wrapper'>
          <div className='nav-category' onClick={() => navigate('/termek-csoport')}>
            Termékek
          </div>
        </div>
        <div className='nav-logo'>
              <img src={Logo} alt='logo' onClick={()=>navigate('/')}/>
              <div className='nav-informations'>
                <p><FaPhone />+36 94 318 590</p>
                <p><TiMail />info@dentalcoopplus.hu</p>
              </div>            
        </div>
        <div className='nav-links'>
            <Link to={'/fiok'}><VscAccount /></Link>
            <Link to={'/kosar'} className='cart'><FaCartShopping />{count > 0 && (<p className='counter'>{count}</p>)}</Link>
            <Link to={'/rolunk'}>Rólunk</Link>
        </div>
    </div>
  )
}

export default NavBar